import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { SimpleCallback } from 'platform-components';

import { LibraryCourseContainerWidgetStore } from 'common.components/widgets.course-container/typings';

export type PostAddCourseContainerToClassPayload = {
    courseContainerSlugs: string[];
    courseId: number;
    onSuccess?: SimpleCallback;
};

const initialState: LibraryCourseContainerWidgetStore = {
    linkCourseContainerToCourseLoadingStatus: LOADING_STATUSES.UNSENT,
};

const slice = createSlice({
    name: 'LIBRARY_COURSE_CONTAINER_WIDGET',
    initialState: initialState,
    reducers: {
        postLinkCourseContainerToCourseRequest: (
            state: LibraryCourseContainerWidgetStore,
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            action: PayloadAction<PostAddCourseContainerToClassPayload>
        ) => {
            state.linkCourseContainerToCourseLoadingStatus = LOADING_STATUSES.LOADING;
        },
        postLinkCourseContainerToCourseError: (state: LibraryCourseContainerWidgetStore) => {
            state.linkCourseContainerToCourseLoadingStatus = LOADING_STATUSES.ERROR;
        },
        postLinkCourseContainerToCourseSuccess: (state: LibraryCourseContainerWidgetStore) => {
            state.linkCourseContainerToCourseLoadingStatus = LOADING_STATUSES.SUCCESS;
        },
    },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
